import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsSliderComponent } from './tabs-slider.component';
import { IconsModule } from '../../design/icons.module';
import { HasPermissionModule } from '../../directives/has-permission/has-permission.module';

@NgModule({
  declarations: [
    TabsSliderComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    HasPermissionModule
  ],
  exports: [TabsSliderComponent]
})
export class TabsSliderModule{}
